
/* SMITHING — T-shirt omaggio Chapter One */

(function () {
  const root = window.Shopify?.routes?.root || '/';
  let checking = false;
  let timer = null;

  async function getCart() {
    const response = await fetch(root + 'cart.js', {
      cache: 'no-store'
    });

    if (!response.ok) {
      throw new Error('Impossibile leggere il carrello');
    }

    return response.json();
  }

  function getConfig() {
    const element = document.getElementById(
      'smithing-gift-config'
    );

    if (!element) {
      console.warn('SMITHING: configurazione non trovata');
      return null;
    }

    return JSON.parse(element.textContent);
  }

  async function checkGift() {
    if (checking) return;
    checking = true;

    try {
      const config = getConfig();
      if (!config) return;

      const eligibleIds = new Set(
        (config.eligibleProductIds || []).map(String)
      );

      if (!eligibleIds.size) {
        console.warn('SMITHING: nessun prodotto idoneo');
        return;
      }

      const cart = await getCart();

      
const hoodieQuantity = cart.items.reduce(
  (total, item) =>
    total + (
      eligibleIds.has(String(item.product_id)) &&
      String(item.product_id) !== String(config.giftProductId)
        ? item.quantity
        : 0
    ),
  0
);


      const gifts = cart.items.filter(item =>
        String(item.product_id) === String(config.giftProductId) &&
        item.properties?._smithing_promo_gift === 'yes'
      );

      console.log('SMITHING:', {
        felpe: hoodieQuantity,
        regali: gifts.length
      });

      if (hoodieQuantity >= 2 || !gifts.length) return;

      for (const gift of gifts) {
        const response = await fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: gift.key,
            quantity: 0
          })
        });

        if (!response.ok) {
          throw new Error('Rimozione regalo non riuscita');
        }
      }

      if (window.location.pathname.replace(/\/$/, '') === '/cart') {
  sessionStorage.removeItem('smithing_reopen_cart');
} else {
  sessionStorage.setItem('smithing_reopen_cart', 'yes');
}

window.location.reload();
    } catch (error) {
      console.error('SMITHING:', error);
    } finally {
      checking = false;
    }
  }

  function scheduleCheck() {
    clearTimeout(timer);
    timer = setTimeout(checkGift, 1200);
  }

  /* AGGIUNTA DEL REGALO */

  document.addEventListener('click', async function (event) {
    const button = event.target.closest(
  '#smithing-add-gift, #smithing-cart-page-add-gift'
);
    if (!button) return;

    event.preventDefault();

    const select = document.querySelector(
  button.id === 'smithing-cart-page-add-gift'
    ? '#smithing-cart-page-gift-size'
    : '#smithing-gift-size'
);

    if (!select || !select.value) {
      alert('Seleziona prima la taglia della T-shirt.');
      return;
    }

    if (button.disabled) return;

    button.disabled = true;
    button.textContent = 'AGGIUNTA IN CORSO...';

    try {
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: Number(select.value),
            quantity: 1,
            properties: {
              _smithing_promo_gift: 'yes'
            }
          }]
        })
      });

      if (!response.ok) {
        throw new Error('Impossibile aggiungere il regalo');
      }

      sessionStorage.setItem('smithing_reopen_cart', 'yes');
      window.location.reload();
    } catch (error) {
      alert('Si è verificato un errore. Riprova.');
      button.disabled = false;
      button.textContent = 'AGGIUNGI IL REGALO GRATIS';
    }
  });

  /* CONTROLLO DOPO MODIFICHE AL CARRELLO */

  document.addEventListener('DOMContentLoaded', scheduleCheck);
  document.addEventListener('change', scheduleCheck);
  document.addEventListener('click', scheduleCheck);
  document.addEventListener('cartdrawer:opened', scheduleCheck);
  document.addEventListener('cart:updated', scheduleCheck);



/* Riapertura carrello dopo la rimozione del regalo */

document.addEventListener('DOMContentLoaded', function () {
  if (sessionStorage.getItem('smithing_reopen_cart') !== 'yes') {
    return;
  }

  sessionStorage.removeItem('smithing_reopen_cart');

  setTimeout(function () {
    
const cartDrawer = document.querySelector('cart-drawer');
const cartButton = cartDrawer?.querySelector('summary.header__icon');

if (cartButton && !cartButton.closest('details').open) {
  cartButton.click();
}

  }, 700);
});

})();
